import jQuery from "jquery";
(function (far, $) {
  far.datepicker = {};

  //#region Public functions ====================================================

  far.datepicker.initialize = function () {
    addEventListenerDatepicker();
  };

  //#endregion

  //#region Private functions ===================================================

  function addEventListenerDatepicker() {
    $(".js-datepicker").click(function () {
      $("#date-filtering").toggle();
    });

    $(".js-datepicker-compilation").click(function () {
      $("#date-filtering-compilation").toggle();
    });
  }

  //#endregion
})(window.far || (window.far = {}), jQuery);
